module.exports = __webpack_public_path__ + "static/media/bfile-snowmobile.04085595.svg";


//////////////////
// WEBPACK FOOTER
// ./src/scenes/Wizard/parts/images/bfile-snowmobile.svg
// module id = 208
// module chunks = 0